import React, { useState, useEffect, useContext } from 'react';

import * as net from "../../lib/net";

import Kid_Notor from "./kund/kid_notor";
import Kid_Open from "./kund/kid_open";
import Dt_Cal from "../../lib/ui/dt_cal";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pos_Kund extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.kra = [];
    this.state.aa = [];

    this.state.wnds = {};
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
    this.kids();
  }

  body_style() {
      var css = {};
      css.height = window.innerHeight - 280;
      return css;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 250;
      return css;
  }
  onUnitChange(e) {
        this.setState({unit: e.value});
  }

  kid_edit(row) {
      var self = this;
      var wnds = {};
      wnds.kidopen = true;
      wnds.kid = row.krr00.kid;
      wnds.kro = row;
      self.setState({wnds: wnds });
  }
  notor() {
      var self = this;
      var wnds = {};
      wnds.kidnotor = true;
    self.setState({wnds: wnds });
  }

  kids() {
    var self = this;
    var prm = {};
    prm.req = "kreg.kreg_wrk.kreg_list";
    //prm.avd = this.state.avd;
    //prm.fplu = datum;
    //prm.tplu = datum;

    //gda.wndLoading("Hämtar");
    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret.rca));

        var o = {};
        //o.deps = ret.rco;
        //alert(JSON.stringify(o));
        self.setState({kra: ret.rca });
        //toastr.success("OK", "SAPI");
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
        //gda.wndError(txt);
    });
  }

  render() {
    return (
    <div className="web-app">

    <div className="flex-row">
        <Dt_Cal startdatum="2020-02-01" getValue={(e)=> this.setState({seldate: e}) }/>
        <select className="form-control sel_input" placeholder="Välj avdelning">
            { this.state.aa.map((row, key) =>
            <option key={key} value={row.id}>{row.text}</option>
            )}
        </select>
        <div className="flex"></div>
        <button className="btn btn-hw-blue w150 ripple" onClick={() => this.notor() } aria-label="System" >
            UNDERLAG
        </button>
    </div>
    <div className="divider_orange"></div>

    <div className="web-row">
        <table className="table table-bordered table-hover tb fixed_header">
            <thead>
            <tr>
                <th>KID</th>
                <th>Företag</th>
                <th>Namn</th>
                <th>Orgnr</th>
                <th>Telefon</th>
                <th>Epost</th>
                <th></th>
            </tr>
            </thead>
            <tbody style={ this.tb_style() }>
            { this.state.kra.map((row, key) =>
            <tr key={key} onDoubleClick={() => this.kid_edit(row) }>
                <td>{ row.krr00.kid }</td>
                <td>{ row.krr00.company.toswe() }</td>
                <td>{ row.krr00.namn.toswe() }</td>
                <td>{ row.krr00.orgnr }</td>
                <td>{ row.krr00.tfn }</td>
                <td>{ row.krr00.email }</td>
                <td onClick={() => this.kid_edit(row) }><i className="fa fa-cog text-danger"></i></td>
            </tr>
            )}
            </tbody>
        </table>
    </div>

        { this.state.wnds.kidnotor ? <Kid_Notor wnds={this.state.wnds} ctx={this} backdrop={true}/> : null }
        { this.state.wnds.kidopen ? <Kid_Open wnds={this.state.wnds} ctx={this} backdrop={true}/> : null }
    </div>
  );
    }
}
export default Pos_Kund;
